module.exports = __webpack_public_path__ + "f5d8b1fd4bb9b03fb9dc5ab54f7d9e69.svg";